module.exports = "<!-- <app-top-bar></app-top-bar>\n<div class=\"cat__content padding_top0\">\n     <router-outlet></router-outlet>  \n     <cat-footer></cat-footer> \n</div> -->\n\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main